// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgTimer = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 5.25a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m0 2.5a.75.75 0 0 1 .746.673l.004.077v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m3-8a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5z"
    />
  </svg>
);
export const TimerIcon = forwardRef(SvgTimer);
